import { eventsQueryKeys, partnerEventsQueryKeys } from './query-keys';

/** Invalidate and refetch mounted event detail screens (admin + partner query keys). */
export const refreshEventDetailQueries = async (queryClient, eventId) => {
  const id = String(eventId ?? '').trim();
  if (!id || !queryClient) {
    return;
  }

  await queryClient.invalidateQueries({ queryKey: eventsQueryKeys.detail(id) });
  await queryClient.invalidateQueries({ queryKey: partnerEventsQueryKeys.detail(id) });
  await queryClient.refetchQueries({
    queryKey: eventsQueryKeys.detail(id),
    type: 'active',
  });
  await queryClient.refetchQueries({
    queryKey: partnerEventsQueryKeys.detail(id),
    type: 'active',
  });
};
